import {
  useContext,
  createContext,
  useState,
  type Dispatch,
  type SetStateAction,
  type PropsWithChildren,
} from 'react';

export type PreviewMediaType = 'web' | 'social' | 'mail';

/**
 * プレビューのページタイプの state
 * - web: PR TIMES Web
 * - social: ソーシャル
 * - mail: メール
 */
const previewMediaTypeContext = createContext<PreviewMediaType>('web');
const setPreviewMediaTypeContext = createContext<
  Dispatch<SetStateAction<PreviewMediaType>>
>(() => undefined);

export function PreviewMediaTypeProvider({
  children,
  initialValue = 'web',
}: PropsWithChildren<{readonly initialValue?: PreviewMediaType}>) {
  const [mediaType, setMediaType] = useState<PreviewMediaType>(initialValue);

  return (
    <previewMediaTypeContext.Provider value={mediaType}>
      <setPreviewMediaTypeContext.Provider value={setMediaType}>
        {children}
      </setPreviewMediaTypeContext.Provider>
    </previewMediaTypeContext.Provider>
  );
}

export const useGetPreviewMediaType = () => {
  return useContext(previewMediaTypeContext);
};

export const useSetPreviewMediaType = () => {
  const value = useContext(setPreviewMediaTypeContext);

  if (value === undefined) {
    throw new Error(
      'useSetPreviewMediaType を使用するコンポーネントは setPreviewMediaTypeContext でラップする必要があります。 ',
    );
  }

  return value;
};
